import './styles.css';
import { mountInputsPanel } from './ui/inputs-panel';
import { mountQuestionsPanel } from './ui/questions-panel';
import { mountResize } from './ui/resize';
import { mountTopbar } from './ui/topbar';
import { mountImagesPanel } from './ui/images-panel';
import { openPresetsModal } from './ui/presets-modal';
import { openExpertModal } from './ui/expert-modal';

function byId<T extends HTMLElement>(id: string): T {
  const el = document.getElementById(id);
  if (!el) throw new Error(`Missing element #${id}`);
  return el as T;
}

byId<HTMLButtonElement>('presets-btn').addEventListener('click', () => openPresetsModal());
byId<HTMLButtonElement>('expert-btn').addEventListener('click', () => openExpertModal());

const EDITOR_HIDDEN_KEY = 'espolon-editor-hidden';
const imagesPanelEl = byId('images-panel');
const editorToggleBtn = byId<HTMLButtonElement>('editor-toggle-btn');
const applyEditorHidden = (hidden: boolean): void => {
  imagesPanelEl.classList.toggle('editor-hidden', hidden);
  editorToggleBtn.classList.toggle('active', !hidden);
};
applyEditorHidden(localStorage.getItem(EDITOR_HIDDEN_KEY) === '1');
editorToggleBtn.addEventListener('click', () => {
  const next = !imagesPanelEl.classList.contains('editor-hidden');
  localStorage.setItem(EDITOR_HIDDEN_KEY, next ? '1' : '0');
  applyEditorHidden(next);
});

mountInputsPanel({
  container: byId('inputs-sections'),
});

mountQuestionsPanel({
  container: byId('questions-container'),
  panel: byId('questions-panel'),
  editModeBtn: byId<HTMLButtonElement>('edit-mode-btn'),
  randomizeBtn: byId<HTMLButtonElement>('randomize-btn'),
});

mountResize({
  handle: byId('resize-handle-right'),
  panel: byId('questions-panel'),
  side: 'left',
  min: 320,
  centerMin: 400,
});

mountTopbar({
  countSlider: byId<HTMLInputElement>('parallel-count'),
  countValue: byId('parallel-count-value'),
  generateBtn: byId<HTMLButtonElement>('generate-btn'),
  batchModeBtn: byId<HTMLButtonElement>('batch-mode-btn'),
});

mountImagesPanel({
  baseImageSection: byId('base-image-section'),
  areasSection: byId('areas-section'),
  grid: byId('images-grid'),
  lightbox: byId('lightbox'),
  lightboxStage: byId('lightbox-stage'),
  lightboxInfo: byId('lightbox-info'),
  lightboxClose: byId<HTMLButtonElement>('lightbox-close'),
  lightboxPrev: byId<HTMLButtonElement>('lightbox-prev'),
  lightboxNext: byId<HTMLButtonElement>('lightbox-next'),
  lightboxDownload: byId<HTMLButtonElement>('lightbox-download'),
  lightboxPhotoToggle: byId<HTMLButtonElement>('lightbox-photo-toggle'),
  lightboxBaseToggle: byId<HTMLButtonElement>('lightbox-base-toggle'),
  lightboxResize: byId('lightbox-resize'),
  lightboxPhotoOverlay: byId('lightbox-photo-overlay'),
  lightboxTopbarLeft: byId('lightbox-topbar-left'),
  lightboxModeButtons: Array.from(
    document.querySelectorAll<HTMLButtonElement>('.lightbox-mode-btn'),
  ),
  lightboxModeSelect: byId<HTMLSelectElement>('lightbox-mode-select'),
  lightboxInfoBtn: byId<HTMLButtonElement>('lightbox-info-btn'),
  infoPopover: byId('info-popover'),
  errorPopover: byId('error-popover'),
  downloadAllBtn: byId<HTMLButtonElement>('download-all-btn'),
  clearAllBtn: byId<HTMLButtonElement>('clear-all-btn'),
  modeSelect: byId<HTMLSelectElement>('images-mode-select'),
});

const headerEl = document.querySelector<HTMLElement>('.header');
if (headerEl) {
  const syncHeaderHeight = () => {
    document.documentElement.style.setProperty(
      '--header-height',
      `${Math.ceil(headerEl.getBoundingClientRect().height) - 1}px`,
    );
  };
  syncHeaderHeight();
  new ResizeObserver(syncHeaderHeight).observe(headerEl);
}

